import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EbwModalService } from '@ebw-monorepo/modal';
import { PsaService } from '../../../../services/psa.service';

@Component({
  selector: 'ebw-monorepo-update-event-probabilities',
  templateUrl: './update-event-probabilities.component.html',
  styleUrls: ['./update-event-probabilities.component.scss']
})
export class UpdateEventProbabilitiesComponent implements OnInit {
  probabilita: number | null = null;
  note = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _psaService: PsaService,
    private _dialogRef: MatDialogRef<UpdateEventProbabilitiesComponent>,
    private _ebwModalService: EbwModalService
  ) {}

  ngOnInit(): void {
    const { probabilita, note } = this.data;
    this.probabilita = probabilita || null;
    this.note = note;
  }

  // Logica per annullare
  onCancel = () => this._dialogRef.close();

  /**
   * Method to modify the probability of the relationship
   */
  onSave(): void {
    const body = {
      evento_rischio_id: this.data.evento_rischio_id,
      schema_idropotabile_id: this.data.schema_idropotabile_id,
      probabilita: this.probabilita,
      note: this.note
    };

    this._psaService._updateRelEvent(body).subscribe((response) => {
      if (response.error > 0) {
        this._ebwModalService.openErrorModal({ title: response.errorDescription, content: response.message });
        return;
      }
      this._dialogRef.close('UPDATED');
    });
  }
}
